import { useSyncExternalStore } from "react";

/**
 * Returns `true` on the client after hydration, `false` during SSR.
 * Use this to guard code that depends on client-only APIs (e.g. localStorage)
 * without causing a hydration mismatch.
 * @see https://react.dev/reference/react/useSyncExternalStore
 * @returns Whether the component has hydrated on the client
 */
export default function useIsClient(): boolean {
  return useSyncExternalStore(
    () => () => {},
    () => true,
    () => false,
  );
}
